// extracted by mini-css-extract-plugin
export default {"header":"modal_header__Gr3nP","main_section":"modal_main_section__4Gbih","model_button":"modal_model_button__9j-zu","bdy":"modal_bdy__buu7Y"};